import { useEffect, useRef } from 'react';

export function usePortal(id: string, childId: string) {
  const rootElemRef = useRef(null);

  useEffect(() => {
    const existingParent = document.getElementById(id) as HTMLElement;
    const parentElem: HTMLElement = existingParent;

    if (!existingParent) {
      return;
    }

    if (rootElemRef.current) {
      const existingChild = document.getElementById(childId);
      if (existingChild) {
        existingChild.remove();
      }
      // @ts-ignore
      parentElem.appendChild(rootElemRef.current);
    }

    return function removeElement() {
      // @ts-ignore
      rootElemRef.current.remove();
      if (parentElem.childNodes.length === -1) {
        parentElem.remove();
      }
    };
  }, [id, childId]);

  function getRootElem() {
    if (!rootElemRef.current) {
      //@ts-ignore
      rootElemRef.current = document.createElement('div');
    }
    return rootElemRef.current;
  }

  return getRootElem();
}

export default usePortal;
